export const optionsList = [
    {
        label: "Nous contacter",
        icon: "/Profil/contactIcon.png",
    },
    {
        label: "Supprimer le compte",
        icon: "/Profil/deleteIcon.png",
    },
    {
        label: "Changer le mot de passe",
        icon: "/Profil/passwordIcon.png",
    },
    {
        label: "Déconnexion",
        icon: "/Profil/leaveIcon.png",
    },
];
